// extracted by mini-css-extract-plugin
export default {"mydiv":"MySlider_mydiv__r7Utl","mydiv1":"MySlider_mydiv1__WePgg","mydiv2":"MySlider_mydiv2__xfDXp","earnbtn":"MySlider_earnbtn__DNAYC","overlay":"MySlider_overlay__mgE71"};